import React, { PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { getUserInitialCompletion } from '../../redux/thunks/user/user'
import { InitState } from '../../redux/reducers/root/initialState'
import { FeaturesSwitchProvider } from '../../utils/features/FeatureSwitchContext'
import { initDatadogLocal } from '../datadog/datadog'

const ProtectedRoute = (props: PropsWithChildren<{}>) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const dispatch = useAppDispatch()
  const { ssoId } = useAppSelector((state: InitState) => state.userFeature)
  const checkUserAuthenticated = useCallback(async () => {
    if (!ssoId) {
      await getUserInitialCompletion()(dispatch).then((isUserAuthenticated) => setIsLoggedIn(isUserAuthenticated))
    } else {
      setIsLoggedIn(true)
    }
  }, [dispatch, ssoId])

  useEffect(() => {
    void checkUserAuthenticated()
  }, [checkUserAuthenticated, isLoggedIn])

  useEffect(() => {
    if (ssoId) {
      void initDatadogLocal(ssoId)
    }
  }, [ssoId])

  return (
    <React.Fragment>{isLoggedIn && <FeaturesSwitchProvider>{props.children}</FeaturesSwitchProvider>}</React.Fragment>
  )
}
export default ProtectedRoute
